import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

const MAX_PATHS_PER_REQUEST = 1000;
const MAX_REQUEST_BYTES = 90_000;

const textEncoder = new TextEncoder();

const splitIntoRequests = (paths: string[]): string[][] => {
  const requests: string[][] = [];
  let current: string[] = [];
  let currentBytes = 0;
  for (const path of paths) {
    const pathBytes = textEncoder.encode(JSON.stringify(path)).length + 1;
    const isFull = current.length === MAX_PATHS_PER_REQUEST || currentBytes + pathBytes > MAX_REQUEST_BYTES;
    if (current.length > 0 && isFull) {
      requests.push(current);
      current = [];
      currentBytes = 0;
    }
    current.push(path);
    currentBytes += pathBytes;
  }
  if (current.length > 0) {
    requests.push(current);
  }
  return requests;
};

export const useFindExistingAssetPaths = () => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const findExistingAssetPaths = async (paths: string[]): Promise<Set<string>> => {
    const existingPaths = new Set<string>();
    for (const requestPaths of splitIntoRequests(paths)) {
      const response = await api.assets.findExistingAssetPaths(tenantId, { paths: requestPaths });
      for (const existingPath of response.data.existingPaths) {
        existingPaths.add(existingPath);
      }
    }
    return existingPaths;
  };

  return { findExistingAssetPaths };
};
